import { useEffect, useState } from 'react';
import axios from 'axios';
import { X } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const OPTIONS = [
  ['care_provider', 'Care provider'],
  ['supplier', 'Tech supplier'],
  ['sector_org', 'Commissioner or association'],
  ['family', 'Family member'],
  ['general', 'Something else'],
];
const HIDE_ON = ['/portal', '/claim', '/create-listing/pay'];

// One-click "I am a..." prompt shown once per browser after the second page view.
export const AudiencePrompt = ({ pathname }) => {
  const [show, setShow] = useState(false);
  const [thanks, setThanks] = useState(false);
  useEffect(() => {
    if (localStorage.getItem('ctc_audience') || HIDE_ON.some((p) => pathname.startsWith(p))) { setShow(false); return undefined; }
    const n = Number(sessionStorage.getItem('ctc_pv') || 0) + 1;
    sessionStorage.setItem('ctc_pv', String(n));
    if (n < 2) return undefined;
    const t = setTimeout(() => setShow(true), 1500);
    return () => clearTimeout(t);
  }, [pathname]);
  const close = (value) => {
    localStorage.setItem('ctc_audience', value);
    if (value === 'dismissed') { setShow(false); return; }
    const sid = localStorage.getItem('ctc_sid');
    if (sid) axios.post(`${API}/public/track/audience`, { sid, audience: value }).catch(() => {});
    setThanks(true);
    setTimeout(() => setShow(false), 1800);
  };
  if (!show) return null;
  return (
    <div className="fixed bottom-4 left-4 right-4 sm:right-auto sm:w-[340px] z-50 bg-white border border-[#E5E7EB] shadow-xl rounded-xl p-4 animate-fade-in" data-testid="audience-prompt">
      <button type="button" onClick={() => close('dismissed')} aria-label="Close" data-testid="audience-prompt-close"
        className="absolute top-3 right-3 text-gray-400 hover:text-gray-700 transition-colors"><X className="w-4 h-4" /></button>
      {thanks ? <p className="text-sm font-semibold text-[#00857D] py-2" data-testid="audience-prompt-thanks">Thanks, that helps us show you the right things.</p> : (
        <>
          <p className="text-sm font-semibold text-gray-900 pr-6">Help us point you to the right things. I am a…</p>
          <div className="flex flex-wrap gap-2 mt-3">
            {OPTIONS.map(([v, label]) => (
              <button key={v} type="button" onClick={() => close(v)} data-testid={`audience-option-${v}`}
                className="text-xs font-medium border border-[#00A79D]/40 text-[#00857D] rounded-full px-3 py-1.5 hover:bg-[#00A79D] hover:text-white transition-colors">{label}</button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
